import { z } from 'zod';
/**
 * Пагинация по курсору, а не по номеру страницы.
 *
 * Причина практическая. Журнал действий и список сбоев пополняются постоянно,
 * и смещение по номеру страницы на таких данных врёт: пока оператор читает
 * первую страницу, сверху добавляются новые записи, и на второй странице он
 * снова видит часть уже прочитанного. Курсор указывает на конкретную запись,
 * поэтому «дальше» всегда означает «дальше», сколько бы событий ни пришло.
 *
 * Курсор непрозрачный для клиента: это base64 от пары «время + идентификатор».
 * Пара, а не одно время, потому что события внутри одной миллисекунды
 * встречаются, и без второго ключа сортировка была бы неустойчивой.
 */
export const PAGE_LIMIT_DEFAULT = 50;
export const PAGE_LIMIT_MAX = 200;
export const cursorQuerySchema = z.object({
    cursor: z.string().max(400).optional(),
    limit: z.coerce.number().int().min(1).max(PAGE_LIMIT_MAX).default(PAGE_LIMIT_DEFAULT),
});
export function cursorPageSchema(item) {
    return z.object({
        items: z.array(item),
        /** Курсор следующей страницы. null — записей больше нет. */
        nextCursor: z.string().nullable(),
    });
}
//# sourceMappingURL=pagination.js.map